// eslint-disable-next-line no-unused-vars
import React from 'react';
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import DecisionButtons
  from 'Components/Modals/IdentityVerificationReviewDetails/reviewDetailsContent/footer/FooterButtons';

// eslint-disable-next-line no-unused-vars
const FooterPicker = ({ resource, onDecisionMade, onReopen }) => {
  return pickWithPriority(resource, [
    [fr.relationships.reopenReview.name, <DecisionButtons resource={resource} onDecisionMade={onDecisionMade} onReopen={onReopen} />],
    [fr.relationships.approveReview.name, <DecisionButtons resource={resource} onDecisionMade={onDecisionMade} />],
  ], null);
};

export default FooterPicker;
